export interface FacebookOfflineEventSet {
  id: string;
  name: string;
}

export const exampleFacebookOfflineEventSet: FacebookOfflineEventSet = {
  name: 'Mock Offline Event Set',
  id: '12351432',
};
